/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useRef, useEffect, useImperativeHandle } from 'react';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { LineView, HeaderView } from "./Blocks";
import { useSelector } from "react-redux";
import { idNamingConversion, checkComponentPermission, currencyFormat, capitalizeFirstLetter, getColumnWidth, checkCRUDPermission, exportCommonFile } from '../../../../../helpers/utilities';
import { Box } from "@mui/material";
import managementActions from "../../../Management/redux/actions";
import unitActions from "../../../../Product/Setup/redux/actions";
import productActions from "../../../../Product/Product/redux/actions";
import younoteAdminActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { emptyValidation, customEmailOptionalValidation } from "../../../../../helpers/validation";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { toast } from 'react-toastify';
import { AESEncrypt } from "../../../../../helpers/Crypto";
import { templateType } from '../../../../../config/constant';
import { customSort } from '../../../../../helpers/sort';


export const CustomForm = React.forwardRef((props, ref) => {
    const { showDetails, schedulingId, view, classes, clsx, type, dispatch, history } = props;
    const childRef = useRef('');
    const { getData } = useSelector(state => state.crudReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { unitMesurementdetails } = useSelector(state => state.productSetupReducer);
    const { workflowDetails, frequencyDetails } = useSelector(state => state.younoteAdminSetupReducer);
    const { myProductdetails, productPrices } = useSelector(state => state.productProductReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, createData } = useSelector(state => state.crudReducer);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [lines, setLines] = useState([]);
    const [allLines, setAllLines] = useState([]);
    const [dLines, setDLines] = useState([]);
    const [search, setSearch] = useState('');
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const [form, setForm] = useState({});
    const [error, setError] = useState({});

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        loadTasks();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyCustomer = emptyValidation('Customer', form?.customerId, 'dropdown');
        let emptyFormat = emptyValidation('Invoice Format', form?.billFormat, 'dropdown');
        let emptyPhone = emptyValidation('Phone', form?.phone);
        let emptyEmail = customEmailOptionalValidation('Email', form?.email);
        setError({});
        if (emptyCustomer.isValid && emptyPhone.isValid && emptyFormat.isValid && emptyEmail.isValid) {
            let a = { ...form };
            delete a.customer; delete a.business; delete a.id; delete a.businessId;
            let l = [];
            lines && lines?.length > 0 && lines?.map((element, i) => {
                return l.push({ ...element })
            });
            l?.length > 0 && l?.map((element, i) => {
                delete element.product;
                delete element.business;
                delete element.catalogue;
                delete element.category;
                delete element.hsn;
                delete element.productGroup;
                delete element.productGst;
                delete element.salesUnit;
                delete element.skuUnit; delete element.workflow;
                delete element.universalProduct; delete element.customer;
                delete element.unit; delete element.scheduleFrequency;
                return l.splice(i, 1, { ...element });
            });

            let n = l.length > 0 ? l.filter((el) => { return !el.id; }) : [];
            let updated = l.length > 0 ? l.filter((el) => { return el.id && el.updated; }) : [];
            a.scheduleStatus = a.scheduleStatus ? 'ACTIVE' : 'INACTIVE';
            if (form?.id) {
                a.new = n;
                a.new?.length > 0 && a.new?.map((element, i) => {
                    delete element.updated;
                    return a.new.splice(i, 1, { ...element });
                });
                a.update = updated;
                a.update?.length > 0 && a.update?.map((element, i) => {
                    delete element.updated;
                    return a.update.splice(i, 1, { ...element });
                });
                a.delete = dLines;
            } else {
                a.customerProductSchedule = l;
                a.customerProductSchedule?.length > 0 && a.customerProductSchedule?.map((element, i) => {
                    delete element.updated;
                    return a.customerProductSchedule.splice(i, 1, { ...element });
                });
            }
            dispatch({
                type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "/v1/schedules/customer-schedules",
                title: "Customer Schedules",
                id: form?.id,
                details: a
            })
        } else {
            setError({
                customerId: emptyCustomer.errors,
                phone: emptyPhone.errors,
                email: emptyEmail.errors,
                billFormat: emptyFormat.errors
            })
        }
        childRef?.current?.handleAdjustHeight();
    }


    const changeCustomer = (value) => {
        if (value?.isHold) {
            setError({
                ...error,
                customerId: 'Please release the Customer from ON-HOLD to allow for transaction to be processed.'
            });
            setForm({});
        } else {
            setError({
                ...error,
                customerId: false
            });
            setForm({
                ...form,
                customer: value,
                customerId: value?.id,
                phone: value?.mobile,
                email: value?.email || '',
            });
        }
    }


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            let a = allLines;
            if (search === '') {
                a = allLines;
                setLines(a);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    a = allLines?.filter((el) => {
                        return (el?.product?.productName?.match(new RegExp(search, "i")) ||
                            el?.product?.productId?.match(new RegExp(search, "i")) ||
                            el?.status?.match(new RegExp(search, "i")) ||
                            el?.unit?.name?.match(new RegExp(search, "i")))
                    });
                    setLines(a);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            setLines(getData);
            setAllLines(getData);
        }
    }, [getData]);

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            history.push(`/sales/setup/customer-product-scheduling/${AESEncrypt(createData.id)}/view`, `${type}`);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            toast.dismiss();
            toast.error(text);
        }
        childRef?.current?.handleAdjustHeight();
    }, [createDetails, createError]);

    const lineSubmit = (data, lineId = '') => {
        if (lineId !== '') {
            let index = lines.findIndex((d, i) => lineId === i);
            if (index >= 0) {
                data.updated = true;
                lines.splice(index, 1, data);
                allLines.splice(index, 1, data);
            }
        } else {
            setLines((prevState) => {
                return [...prevState, data];
            });
            setAllLines((prevState) => {
                return [...prevState, data];
            });
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            history.push(`/sales/setup/customer-product-scheduling/${AESEncrypt(schedulingId)}/view`, `${type}`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            toast.dismiss();
            toast.error(text);
        }
        childRef?.current?.handleAdjustHeight();
    }, [editDetails, editError]);


    const loadTasks = () => {
        if (type === 'create') {
            customerApi();
        }
        productApi('');
        dispatch({
            type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: younoteAdminActions.FREQUENCY_START, url: 'v1/schedules/schedule-frequency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: younoteAdminActions.WORKFLOW_START, url: 'v1/schedules/workflow', filter: {
                order: 'id  desc'
            }
        });
    }

    const deleteLine = (id) => {
        let index = lines.findIndex((d, i) => id === i);
        let fLines = lines.find((d, i) => id === i);
        if (index >= 0) {
            delete fLines.product;
            delete fLines.business;
            delete fLines.catalogue;
            delete fLines.category;
            delete fLines.hsn;
            delete fLines.productGroup;
            delete fLines.productGst;
            delete fLines.salesUnit;
            delete fLines.skuUnit;
            delete fLines.universalProduct; delete fLines.workflow; delete fLines.customer;
            delete fLines.unit; delete fLines.scheduleFrequency;
            setDLines([
                ...dLines, fLines
            ]);
            lines.splice(index, 1);
            setAllLines({ ...lines });
        }
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);

        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const handleScheduleEdit = (t) => {
        history.push(`/sales/setup/customer-product-scheduling/${AESEncrypt(schedulingId)}/${t}`, `${t}`);
    }

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }

    useEffect(() => {
        if (businessDetails && businessDetails?.businessId && !schedulingId) {
            let a = customObject(templateType, businessDetails?.businessDocumentTemplates[0]?.self_bill_template);
            setForm({
                billFormat: a?.id || 'format1',
                scheduleStatus: true,
                sendNotification: true,
                notifyPhone: true,
                notifyEmail: true
            })
        }
    }, [businessDetails]);

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            customerApi('', data.customerId);
            data.scheduleStatus = data.scheduleStatus === 'ACTIVE' ? true : false;
            setForm({ ...data });
            dispatchFilter(data?.customerId);
        }
    }))

    const dispatchFilter = (customerId) => {
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: `v1/schedules/customer-product-schedules/customerwise/${customerId}`,
            skip: 0,
            filter: {
                order: 'id desc'
            }
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        customSort(sortBy, sortOrder, lines);
    }

    return (
        <Fragment>
            <CustomAccordion
                title={'Customer Product Scheduling'}
                top={"0"}
                topVisible={"50px"}
                zIndex={9}
                showDetails={showDetails}
                index={0}
                ref={childRef}
                component={
                    <Box
                        className={clsx(classes.removeUnderline, classes.positionRelative)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => handleSubmit(e)}>
                        {
                            showDetails ? <div className={classes.textAlignCenter}>
                                <div className={classes.loadMoreCircle}></div>
                            </div> : <HeaderView
                                {...props}
                                form={form}
                                error={error}
                                view={view}
                                handleScheduleEdit={(t) => handleScheduleEdit(t)}
                                changeCustomer={(data) => changeCustomer(data)}
                                loader={createLoader || editLoader}
                                customerApi={(search = '', id = '') => customerApi(search, id)}
                                changeHandler={(e, name = '') => changeHandler(e, name)}
                                customObject={(details, id) => customObject(details, id)}
                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                customerDetails={customerDetails}
                            />
                        }
                    </Box>
                }
            />
            <CustomAccordion
                title={'Products Lines'}
                top={"49"}
                topVisible={"150px"}
                zIndex={7}
                showDetails={showDetails}
                index={1}
                ref={childRef}
                component={
                    <LineView
                        {...props}
                        sortOrder={sortOrder}
                        sortBy={sortBy}
                        onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                        lines={lines}
                        allLines={allLines}
                        headerView={view}
                        form={form}
                        handleSearch={(s) => setSearch(s)}
                        dispatch={dispatch}
                        unitMesurementdetails={unitMesurementdetails}
                        myProductdetails={myProductdetails}
                        productPrices={productPrices}
                        workflowDetails={workflowDetails}
                        productApi={(s = '', id = '') => productApi(s, id)}
                        exportCommonFile={(name, data = 'existing', selected = [], extension = 'xlsx') => exportCommonFile(name, data, selected, extension)}
                        frequencyDetails={frequencyDetails}
                        getColumnWidth={(head, v) => getColumnWidth(head, v)}
                        lineSubmit={(data, id) => lineSubmit(data, id)}
                        productActions={productActions}
                        capitalizeFirstLetter={(v) => capitalizeFirstLetter(v)}
                        deleteLine={(id) => deleteLine(id)}
                        customObject={(details, id) => customObject(details, id)}
                        idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        checkCRUDPermission={(feature, type, name) => checkCRUDPermission(feature, type, name)}
                        checkComponentPermission={(feature, type, name) => checkComponentPermission(feature, type, name)}
                        search={search}
                    />
                }
            />
        </Fragment>
    )
})